/*
 * ceq-attachments-accordion.js
 * Geladen von: sections/ceq-attachments-accordion.liquid
 *              + sections/ceq-customer-case-detail.liquid (Equipment-Karten)
 * Scope: AJAX Quick-Add fuer Attachment-Karten (.ceq-attachment-item__add).
 *
 * Findet alle .ceq-attachment-item__add[data-variant-id] Buttons und haengt
 * Click-Handler an. POSTet zu /cart/add.js mit Cart-Drawer-Sections, oeffnet
 * danach den Drawer (renderContents oeffnet automatisch).
 */
(function () {
  'use strict';

  const SECTIONS_TO_FETCH = ['cart-drawer', 'cart-icon-bubble'];
  const ROUTE = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  // originalHtml statt textContent: Buttons enthalten ein SVG-Icon —
  // textContent-Restore wuerde das Icon durch Leertext ersetzen.
  function setButtonState(btn, state, originalHtml) {
    btn.dataset.state = state || '';
    if (state === 'loading') {
      btn.disabled = true;
      btn.textContent = '…';
    } else if (state === 'success') {
      btn.disabled = false;
      btn.textContent = '✓';
      setTimeout(() => {
        btn.dataset.state = '';
        btn.innerHTML = originalHtml;
      }, 1800);
    } else if (state === 'error') {
      btn.disabled = false;
      btn.textContent = '!';
      setTimeout(() => {
        btn.dataset.state = '';
        btn.innerHTML = originalHtml;
      }, 2400);
    } else {
      btn.disabled = false;
      btn.innerHTML = originalHtml;
    }
  }

  function addToCart(variantId, btn, originalHtml) {
    const drawer = getCartDrawer();
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (drawer) {
      // Standard-Theme-Pattern: einzelnes 'sections' Feld mit Komma-Liste
      // (statt mehrfacher 'sections[]'-Entries — beides valid, aber consistent halten).
      formData.append('sections', SECTIONS_TO_FETCH.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    setButtonState(btn, 'loading', originalHtml);

    fetch(ROUTE, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status) {
          // Shopify-Fehler-Response (z.B. nicht auf Lager)
          throw new Error(response.description || response.message || 'Cart-Fehler');
        }

        setButtonState(btn, 'success', originalHtml);

        if (drawer && response.sections) {
          drawer.renderContents(response);
        } else if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'ceq-attachments-accordion',
            productVariantId: variantId,
            cartData: response,
          });
        }
      })
      .catch((err) => {
        console.error('[ceq-attachments-accordion] add-to-cart failed', err);
        setButtonState(btn, 'error', originalHtml);
      });
  }

  function onClick(event) {
    const btn = event.target.closest('.ceq-attachment-item__add[data-variant-id]');
    if (!btn) return;
    if (btn.disabled) return;
    event.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const originalHtml = btn.dataset.originalHtml || btn.innerHTML;
    if (!btn.dataset.originalHtml) btn.dataset.originalHtml = originalHtml;
    addToCart(variantId, btn, originalHtml);
  }

  function init() {
    document.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
